<template>
  <div class="account-pages mt-5 mb-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-4">
          <div class="card">
            <div class="card-body p-4">
              <div class="text-center w-75 m-auto">
                <div class="auth-logo">
                  <a href="index.html" class="logo logo-dark text-center">
                    <span class="logo-lg">
                      <!-- <img
                        src="../assets/images/logo-dark.png"
                        alt=""
                        height="22"
                      /> -->
                    </span>
                  </a>
                </div>
                <img
                  src="@/assets/adminlte/images/logo.png"
                  alt=""
                  width="85%"
                />
                <p class="text-muted">
                  Enter your uername and password to access admin panel.
                </p>
              </div>

              <div class="mb-2">
                <label for="emailaddress" class="form-label"
                  >Username<span class="text-primary">*</span></label
                >
                <input
                  class="form-control"
                  type="text"
                  v-model="username"
                  placeholder="Username"
                />
                <span class="text-primary" v-if="errors && errors.username">{{
                  errors.username[0]
                }}</span>
              </div>

              <div class="mb-2">
                <label for="password" class="form-label"
                  >Password<span class="text-primary">*</span></label
                >
                <div class="input-group input-group-merge">
                  <input
                    type="password"
                    class="form-control"
                    v-model="password"
                    placeholder="Password"
                  />
                </div>
                <span class="text-primary" v-if="errors && errors.password">{{
                  errors.password[0]
                }}</span>
              </div>

              <label class="form-check-label text-primary" v-if="error_msg">
                {{ error_msg }}
              </label>
              <div class="mb-3">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="checkbox-signin"
                    checked
                  />
                  <label class="form-check-label" for="checkbox-signin">
                    Remember me
                  </label>
                </div>
              </div>

              <div class="d-grid mb-0 text-center">
                <button
                  class="btn btn-primary"
                  v-if="!loader"
                  @click="login()"
                  type="button"
                >
                  Log In
                </button>
                <center>
                  <b-spinner v-if="loader" variant="success"></b-spinner>
                </center>
              </div>
            </div>
            <!-- end card-body -->
          </div>
          <!-- end card -->

          <!-- <div class="row mt-3">
            <div class="col-12 text-center">
              <p>
                <router-link to="/site/forgot" class="text-muted ms-1"
                  >Forgot your password?</router-link
                >
              </p>
            </div>
          </div> -->
          <!-- end row -->
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </div>
    <!-- end container -->
  </div>
  <!-- end page -->
</template>
<script>
export default {
  name: "LoginView",
  data() {
    return {
      username: null,
      password: null,
      errors: [],
      error_msg: null,
      loader: false,
    };
  },
  methods: {
    login() {
      //Save or update User Details
      this.errors = [];
      this.error_msg = null;
      this.loader = true;
      let apiUrl = process.env.VUE_APP_URL + "api/login";
      let method_type = "post";
      fetch(apiUrl, {
        method: method_type,
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          username: this.username,
          password: this.password,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === true) {
            var userData = {
              user: data.user,
              user_type: data.user_type,
              token: data.token,
              status: true,
              vendor: data.vendor || null,
            };
            localStorage.setItem("userData", JSON.stringify(userData));
            if (data?.user?.type === "Admin") {
              window.location.href = "/admin/dashboard";
            } else if (data?.user?.type === "Vendor") {
              window.location.href = "/admin/dashboard";
            } else {
              window.location.href = "/admin/products";
            }
          } else if (data.status === false) {
            localStorage.clear();
            this.error_msg = data.message;
          } else {
            this.errors = data.errors;
          }
          this.loader = false;
        })
        .catch(function (err) {
          console.log("Login Data", "Error : " + err.message, "error");
        });
    },
  },
};
</script>
